<template>
  <form class="tdesk-form" @submit.prevent="submitForm">
    <form-errors :errors="formErrors" />

    <div class="form-group required">
      <label for="first-name">First Name</label>
      <input
        id="participant-first-name-input"
        v-model="newParticipant.first_name"
        type="text"
        required
      >
    </div>
    <div class="form-group required">
      <label for="last-name">Last Name</label>
      <input
        id="participant-last-name-input"
        v-model="newParticipant.last_name"
        type="text"
        required
      >
    </div>
    <div class="form-group required">
      <label for="e-mail">E-Mail</label>
      <input
        id="participant-email-input"
        v-model="newParticipant.email"
        type="email"
        required
      >
    </div>

    <div>
      <button id="submit-participant" class="tdesk-primary-button" type="submit">
        <i class="fas fa-save" />
        Add
      </button>
    </div>
  </form>
</template>
<script>
import { getEligibilityCheckPath } from './helpers/courseEligibility';
import FormErrors from "../../../components/form_errors.vue";

  export default {
    components: {FormErrors},
    props: {
      participants: { type: Array, required: true },
      courseId: { type: Number, required: true },
      isPartnerCourse: { type: Boolean, required: true },
    },
    data() {
      return {
        newParticipant: {
          first_name: '',
          last_name: '',
          email: '',
        },
        formErrors: [],
      };
    },
    methods: {
      submitForm() {
        this.checkParticipantEligibility();
      },
      resetForm() {
        this.newParticipant = {
          first_name: '',
          last_name: '',
          email: '',
        };
        this.formErrors = [];
      },
      addNewParticipant() {
        this.$emit('add-participant', { ...this.newParticipant });
        this.resetForm();
      },
      checkParticipantEligibility() {
        const existingParticipant = this.participants.find(
            (participant) => participant.email === this.newParticipant.email,
        );

        if (existingParticipant) {
          this.formErrors = [`You are already registering ${existingParticipant.first_name} ${existingParticipant.last_name} with the email ${this.newParticipant.email}.`];
          return;
        }
        const currentUrlParams = new URLSearchParams(window.location.search);
        // cid needed as this is how admin lms courses map to a course as opposed to /course_id/
        const cid = currentUrlParams.get('cid');
        const paramsObj = {
          email: this.newParticipant.email,
          first_name: this.newParticipant.first_name,
          last_name: this.newParticipant.last_name,
          cid: cid,
          lms_course_id: this.courseId,
          partner_id: this.partnerId,
        };
        const eligibilityCheckPath = getEligibilityCheckPath({isPartnerCourse: this.isPartnerCourse, params: paramsObj});

        $.ajax({
          url: eligibilityCheckPath,
          type: 'GET',
          dataType: 'json',
          contentType: 'application/json',
          success: function(response) {
            if (response.eligible) {
              this.addNewParticipant();
            } else {
              this.formErrors = [response.error_message];

              if (response.error_type === 'incorrect_name_details') {
                this.newParticipant.first_name = response.user_details.first_name;
                this.newParticipant.last_name =  response.user_details.last_name;
              }
            }
          }.bind(this),
          error: function() {
            this.formErrors = ['An error occurred. Please try again or contact support if this issue persists'];
          }.bind(this),
        });
      },
    },
  };
</script>
